module.exports = __webpack_public_path__ + "img/macchina-professionale.93f4d32e.jpg";